import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
    selector: 'tidy-advanced-setup',
    templateUrl: './advanced-setup.html',
    styleUrls: ['./advanced-setup.scss'],
    standalone: false
})
export class AdvancedSetupComponent {

  boundScheduleCall = this.scheduleCall.bind(this);

constructor(private modalController: ModalController) {}

  scheduleCall() {
    // TODO: Implement schedule call functionality
  }

  closeModal() {
    this.modalController.dismiss('advanced-setup-modal');
  }
}
